/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { EPaymentReceiptType } from "../types/EPaymentReceiptType.ts";

/**
 * @description 1 = Invoice | 2 = Receipt |
 */
export const ePaymentReceiptTypeSchema = z
  .union([z.literal(1), z.literal(2)])
  .describe(
    "1 = Invoice | 2 = Receipt | ",
  ) as unknown as ToZod<EPaymentReceiptType>;
